import { ColorEnum } from '@/constants/color'
import ActionButtons from '@/features/pos/components/Cart/parts/EditAutomaticContainersModal/parts/Content/parts/ActionButtons'
import AutomaticContainerList from '@/features/pos/components/Cart/parts/EditAutomaticContainersModal/parts/Content/parts/AutomaticContainerList'
import { EditAutomaticContainersModalActions } from '@/features/pos/components/Cart/parts/EditAutomaticContainersModal/types'
import { AutomaticContainer } from '@/features/pos/components/Cart/parts/Overview/parts/CartItem/types'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { ScrollView, StyleSheet, View } from 'react-native'

export interface EditAutomaticContainersModalContentProps
    extends EditAutomaticContainersModalActions {
    activeContainers: AutomaticContainer[]
    containersToRemove: AutomaticContainer[]
}

const Content: FC<EditAutomaticContainersModalContentProps> = ({
    activeContainers,
    containersToRemove,
    onStageRemoval,
    onRestore,
    onCancel,
    onConfirm,
}) => {
    const { t } = useTranslation()

    return (
        <View style={styles.container}>
            <Typography.Heading variant="h3" numberOfLines={1} style={styles.heading}>
                {t('pos.orderFinalization.cart.editContainers.heading')}
            </Typography.Heading>
            <ScrollView
                style={styles.scrollView}
                contentContainerStyle={styles.scrollContent}
                showsVerticalScrollIndicator={false}
            >
                <AutomaticContainerList
                    containers={activeContainers}
                    action="remove"
                    onAction={onStageRemoval}
                />
                {!!containersToRemove.length && (
                    <View
                        style={[
                            styles.removalSection,
                            !activeContainers.length && styles.removalSectionWithoutActiveList,
                        ]}
                    >
                        <Typography.Heading variant="h4" style={styles.removalHeading}>
                            {t('pos.orderFinalization.cart.editContainers.toRemove')}
                        </Typography.Heading>
                        <AutomaticContainerList
                            containers={containersToRemove}
                            action="restore"
                            onAction={onRestore}
                        />
                    </View>
                )}
            </ScrollView>
            <ActionButtons onCancel={onCancel} onConfirm={onConfirm} />
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        paddingTop: 32,
    },
    heading: {
        color: ColorEnum.Jet700,
        textAlign: 'center',
        marginHorizontal: 16,
    },
    scrollView: {
        flex: 1,
    },
    scrollContent: {
        paddingTop: 24,
        paddingHorizontal: 16,
        paddingBottom: 88,
    },
    removalSection: {
        marginTop: 16,
    },
    removalSectionWithoutActiveList: {
        marginTop: 0,
    },
    removalHeading: {
        color: ColorEnum.Jet700,
        marginBottom: 8,
    },
})

export default Content
